// Import core VUE framework.
import Vue from 'vue'

import consoleEventsInit from './events/console'
import logRocketEventsInit from './events/logrocket'
import tagManagerEventsInit from './events/tag-manager'
import klaviyoEventsInit from './events/klaviyo'
import commissionFactoryEventsInit from './events/commission-factory'
import facebookEventsInit from './events/facebook'

export default (settings, store) => {
  const eventHub = new Vue()

  const initialisers = {
    console: consoleEventsInit,
    logrocket: logRocketEventsInit,
    'gtm-dataLayer': tagManagerEventsInit,
    klaviyo: klaviyoEventsInit,
    'commission-factory': commissionFactoryEventsInit,
    facebook: facebookEventsInit
  }

  for (const [setting, initialiser] of Object.entries(initialisers)) {
    initialiser(eventHub, settings[setting] || {}, store)
  }

  return eventHub
}
